import { render } from "./TrekParagraphComponent.vue?vue&type=template&id=3e930678"
import script from "./TrekParagraphComponent.vue?vue&type=script&lang=js"
export * from "./TrekParagraphComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__